/* eslint-disable react/no-unescaped-entities */
import Header from "@buddieshr/components/header";
import MetaHeader from "@buddieshr/components/metaHeader";
import PageWrapper from "@buddieshr/components/templates/pageWrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import styles from "@buddieshr/styles/alternatives.module.scss";
import { useRouter } from "next/router";
import Argument from "@buddieshr/components/templates/argument";
import Footer from "@buddieshr/components/footer";
import {
  DollarCircleOutlined,
  HeartOutlined,
  ProductOutlined,
  WarningTwoTone,
} from "@ant-design/icons";
import TextColored from "@buddieshr/components/text/textColored";
import TextUnderlined from "@buddieshr/components/text/textUnderlined";
import Image from "next/image";
import ComparisonTable from "@buddieshr/components/comparisonTable";
import { VERSUS_DONUT_BUDDIESHR } from "@buddieshr/utils/constants";
import Link from "next/link";
import { Button, Tag } from "antd";
import IndividualAppVignette from "@buddieshr/components/IndividualAppVignette";
import { PRODUCTS } from "@buddieshr/utils/constants-products";
import LovePanel from "@buddieshr/components/landing/lovePanel";

const ALTERNATIVE_NAME = "Donut";

const AlternativeDonut = () => {
  const { t } = useTranslation();
  const router = useRouter();
  return (
    <>
      <MetaHeader
        title={"Best Donut Alternatives for Engaging Employees - try BuddiesHR"}
        description={t("descriptionContentDonutAlternativeBuddies")}
        currentURL={`https://buddieshr.com/${
          router.locale === "en" ? "" : router.locale
        }/alternatives/donut`}
        currentShare={
          "https://buddieshr.com/img/alternatives/donut-buddies-alternatives.png"
        }
        pageSlug={`alternatives/donut`}
        locale={router.locale}
      />
      <Header />
      <main className={styles.main}>
        <div className={styles.topPanel}>
          <PageWrapper>
            <div className={styles.flexInner}>
              <div className={styles.flexLeft}>
                <div className={styles.tagWrapper}>
                  <Tag
                    size="large"
                    color="red"
                    bordered={false}
                    className={styles.tag}
                    style={{
                      fontSize: 16,
                      padding: "4px 16px",
                      fontWeight: "bold",
                    }}
                  >
                    ALTERNATIVES
                  </Tag>
                </div>
                <h1 className={styles.title}>
                  Discover the <TextColored>best alternative</TextColored> to{" "}
                  {ALTERNATIVE_NAME}
                </h1>
                <div className={styles.description}>
                  How does BuddiesHR compare to {ALTERNATIVE_NAME} Slack app?
                  What the best way to{" "}
                  <a href="https://buddieshr.com/alfy" alt="connect employees">
                    connect employees
                  </a>{" "}
                  together? What’s the best alternative to {ALTERNATIVE_NAME}{" "}
                  Slack bot?
                  <br />
                  <br />
                  Discover why BuddiesHR is a great alternative to{" "}
                  {ALTERNATIVE_NAME}.
                </div>
                <div>
                  <Link
                    href={`/get-started`}
                    alt={"Get started with Buddieshr"}
                  >
                    <Button
                      type="primary"
                      block
                      size="large"
                      style={{ width: 300, maxWidth: "100%" }}
                    >
                      Get Started
                    </Button>
                  </Link>
                </div>
              </div>
              <div className={styles.flexRight}>
                <Image
                  src="/img/alternatives/donut-buddies-alternatives.png"
                  width={367}
                  height={300}
                  priority={true}
                  alt="donut random coffee"
                />
              </div>
            </div>
          </PageWrapper>
        </div>

        <div className={styles.socialProofWrapper}>
          {/* <UsedByLogoBanner /> */}
        </div>
        <div className={styles.top3Reasons}>
          <PageWrapper>
            <h2 className={styles.h2}>
              Top 3 reasons BuddiesHR is the best alternative to{" "}
              {ALTERNATIVE_NAME}
            </h2>
            <div>
              Here are the main reasons why people prefer BuddiesHR over{" "}
              {ALTERNATIVE_NAME}
            </div>
            <div className={styles.reasonWrapper}>
              <div className={styles.reasonElement}>
                <div className={styles.reasonLogo}>
                  <ProductOutlined />
                </div>
                <div className={styles.reasonTitle}>
                  <TextColored>Install only the apps you need</TextColored>
                </div>
                <div className={styles.reasonDesc}>
                  If you don't feel like having a bunch of features you'll never
                  use, choose BuddiesHR for its <b>modular</b> approach
                </div>
              </div>
              <div className={styles.reasonElement}>
                <div className={styles.reasonLogo}>
                  <DollarCircleOutlined />
                </div>
                <div className={styles.reasonTitle}>
                  <TextColored>BuddiesHR is (way) cheaper</TextColored>
                </div>
                <div className={styles.reasonDesc}>
                  Free under 10 users, affordable above that. More than{" "}
                  <b>5 times cheaper</b> than Donut.
                </div>
              </div>
              <div className={styles.reasonElement}>
                <div className={styles.reasonLogo}>
                  <HeartOutlined />
                </div>
                <div className={styles.reasonTitle}>
                  <TextColored>UX people love</TextColored>
                </div>
                <div className={styles.reasonDesc}>
                  Nothing worst than getting lost in too many settings in a
                  clunky external app, right? With BuddiesHR, get a fresh,
                  simple user interface <b>100% in Slack</b>.
                </div>
              </div>
            </div>
          </PageWrapper>
        </div>
        <div className={styles.top3Reasons}>
          <PageWrapper>
            <div className={styles.flexInner}>
              <div className={styles.flexLeft}>
                <h3 className={styles.h2}>
                  Looking for an{" "}
                  <TextUnderlined>
                    alternative to {ALTERNATIVE_NAME} Slack app?
                  </TextUnderlined>
                </h3>
                <div>
                  <Image
                    src="/img/alternative.png"
                    width={400}
                    height={400}
                    alt={`best Alternative to ${ALTERNATIVE_NAME}`}
                  />
                </div>
              </div>
              <div className={styles.flexRight}>
                <div className={styles.whatITitle}>
                  What is {ALTERNATIVE_NAME}
                </div>
                <div className={styles.descColor}>
                  Donut makes strategic connections to help employees achieve
                  common goals and better outcomes. Donut prompts teammates to
                  connect via direct message,
                </div>
                <br />
                <br />
                <div className={styles.whatITitle}>What is BuddiesHR</div>
                <div className={styles.descColor}>
                  BuddiesHR is a suite of Slack apps helping HR teams engage
                  remote employees. Whether if it's for connecting people
                  together, celebrating milestones, birthdays, anniversaries or
                  recognizing people's work, BuddiesHR covers all the needs of
                  remote companies.
                  <br />
                  <br />
                  <b>
                    Apps are modular (install only what you need), 100% in Slack
                    and very simple to use.
                  </b>
                </div>
              </div>
            </div>
          </PageWrapper>
        </div>
        <PageWrapper>
          <div
            style={{
              padding: "30px 24px",
              background: "#fff7f7",
              borderRadius: 10,
            }}
          >
            <div>
              <WarningTwoTone
                twoToneColor={"#ff6a6a"}
                style={{ fontSize: 34, marginBottom: 12 }}
              />
            </div>
            <h2 style={{ marginBottom: 8 }}>
              The problem of using Donut for Slack
            </h2>
            <div>
              Donut is now quite <b>hard to configure</b> and too{" "}
              <b>expensive</b> for most teams. While they grew a lot, the
              product became clunky and difficult to install, configure and
              maintain.
            </div>
          </div>
        </PageWrapper>
        <div className={styles.sectionWrapper}>
          <div className={styles.sectionInner}>
            <PageWrapper width={1100}>
              <h2>Why BuddiesHR is the best alternative to Donut?</h2>
              <div>
                There are multiple reasons why people choose BuddiesHR over
                Donut as it's the best alternative:
                <ul className={styles.listComparison}>
                  <li>
                    <b>It's multiple times cheaper</b>
                  </li>
                  <li>
                    <b>The simplicity of BuddiesHR set up</b> is just a gift
                    when you've experienced the admin dashboard of Donut
                  </li>
                  <li>
                    <b>Install what you need only</b> - Donut is now full of
                    features you may never need.
                  </li>
                  <li>
                    <b>It's better rated</b> by customers (4.8/5 for{" "}
                    <Link
                      href="https://www.g2.com/products/buddieshr/reviews"
                      target="_blank"
                    >
                      BuddiesHR
                    </Link>{" "}
                    versus 4.5 for{" "}
                    <Link
                      href="https://www.g2.com/products/donut/reviews"
                      target="_blank"
                    >
                      Donut
                    </Link>
                    )
                  </li>
                </ul>
              </div>
              <h2>What are the notable features of BuddiesHR</h2>
              <div>
                BuddiesHR main features for Slack include:
                <ul className={styles.listComparison}>
                  <li>Birthday and work anniversary celebrations</li>
                  <li>Random 1:1 Coffee Chats</li>
                  <li>Peer-to-peer recognition & Reward system</li>
                  <li>Surveys, Polls, engagement & eNPS</li>
                  <li>Org-Chart and Employee Directory</li>
                  <li>Async Standup automation</li>
                </ul>
              </div>
              <h2>What's the price of BuddiesHR</h2>
              <p>
                BuddiesHR apps cost $1 per user per month if you use 1 app, if
                you use multiple apps you pay $2 per user per month for ALL
                APPS. (yes yes that's not a typo)
              </p>
            </PageWrapper>
          </div>
        </div>
        <br />
        <br />
        <br />
        <PageWrapper width={1100}>
          <h2 style={{ textAlign: "center" }}>
            Here is what people say about BuddiesHR apps for Slack
          </h2>
          <LovePanel
            style={{ marginTop: 12, marginBottom: 12 }}
            hideTitle
            hideCTA
            showStars={true}
          />
          <div style={{ textAlign: "center", marginTop: 12 }}>
            <Link href="/reviews">
              <Button type="primary" size="large">
                Read more reviews
              </Button>
            </Link>
          </div>
        </PageWrapper>

        <div className={styles.comparisonWrapper}>
          <PageWrapper>
            <ComparisonTable
              features={VERSUS_DONUT_BUDDIESHR}
              competitorName={ALTERNATIVE_NAME}
              competitorLogoUrl="/img/apps/alfy/alternatives/donut.svg"
              app={{
                slug: "buddieshr",
                logoUrl: "/img/logo/logo.png",
                name: "BuddiesHR",
                fullName: "BuddiesHR",
                // shortTitle: "",
              }}
            />
          </PageWrapper>
        </div>
        <div className={styles.installWrapper}>
          <div className={styles.installInner}>
            <div className={styles.list}>
              {PRODUCTS.map((p) =>
                p.show ? (
                  <IndividualAppVignette
                    key={p.id}
                    app={p}
                    className={styles.dreamTeamItem}
                    withDescription={false}
                    withAction={false}
                    withLastName={false}
                  />
                ) : (
                  <></>
                )
              )}
            </div>

            <h2 style={{ marginTop: 18, marginBottom: 16 }}>
              Choose the Best Donut alternative for Slack, Install BuddiesHR
            </h2>
            <Link href={`/get-started`} alt={"Get started with Buddieshr"}>
              <Button
                type="primary"
                block
                size="large"
                style={{ width: 300, maxWidth: "100%" }}
              >
                Get Started
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AlternativeDonut;
